// @flow
import { appApi } from '../config/api.config';
import { API_PATHS, BASE_URL } from '../config/api.constants';
import { createPath } from '../utils';

export const getIndex = (indexFilter: TIndexFilter) => appApi.post(createPath(BASE_URL + API_PATHS.CHARTS + API_PATHS.INDEX, { fundId: indexFilter.fund_id }), { user_id: indexFilter.user_id, from: indexFilter.fromDate, to: indexFilter.toDate })

export const getAssets = (payload: {fundId: number, userId: number}) => appApi.post(createPath(BASE_URL + API_PATHS.CHARTS + API_PATHS.ASSETS, { fundId: payload.fund_id }), { user_id: payload.user_id })